import compose from 'ramda/src/compose';

export const explodeParamsString = str => {
    if(!str || str.length === 0) {
        return {};
    }
    return str.replace('?', '')
        .split('&')
        .reduce((acc, item) => {
            const [key, value] = item.split('=');
            acc[key] = value;
            return acc;
        }, {});
};

export const implodeParamsObject = obj => {
    if(!obj || Object.keys(obj).length === 0) {
        return '';
    }
    return Object.keys(obj)
        .filter(item => obj[item] && obj[item] !== 'null')
        .reduce((acc, item, idx, arr) => `${acc}${item}=${obj[item]}${idx < arr.length - 1 ? '&' : ''}`, '?');
};

export const parseQueryString = compose(implodeParamsObject, explodeParamsString);

export const fixAEMRelURL = url => (url.charAt(0) === '/' ? `${url}.html` : url);
